import { render, staticRenderFns } from "./task-color.vue?vue&type=template&id=ec7e48ea"
import script from "./task-color.vue?vue&type=script&lang=js"
export * from "./task-color.vue?vue&type=script&lang=js"
import style0 from "./task-color.vue?vue&type=style&index=0&id=ec7e48ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports